import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  DropdownButton,
  MenuItem,
  FormGroup,
  InputGroup,
  FormControl,
  ButtonGroup,
  Modal,
  ControlLabel,
  Row,
  Col,
  Glyphicon,
  Checkbox 
} from "react-bootstrap";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createHashHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";
import "../../../style/react-paginating.css";
import {
  getVoucherList,
  updateStatus,
  voucherTransfer,
  getVoucherDetail,
  refundVoucher,
  resendVoucher
} from "../../../redux/actions/voucherActions";
import moment from "moment";
import Dialog from "react-bootstrap-dialog";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import { allUser } from "../../../redux/actions/subAdminActions";

let rand = require("random-key");
import {aclUtil} from "../../util"

const history = createHashHistory();

let isLoading = "false";
class VouchersList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      voucherData: [],
      totalRecords: 0,
      limit: 25,
      search: "",
      perPage: 0,
      currentPage: 1,
      pageCount: 0,
      alertMessage: "",
      msgType: "success",
      menuKey: 'LIST_VOUCHERS',
      path: ["Home", "Manage Vouchers List"],
      links: ["home", "voucherList"],
      show: false,
      voucherNumberSortIcon: "fa fa-sort-down",
      dealTextSortIcon: "fa fa-sort-down",

      direction: "",
      orderBy: "",
      showDialog: false,
      promoid: "",
      show: false,

      note: "",
      voucherID: "",
      status: "",
      popUpStatus: false,
      popUpTransfer: false,
      searchValue: '',
      userList:'',
      popUpTransfer: false,

      popUpRefund: false,
      voucherDetail: '',
      amount: '',
      refundAs: 'StoreCredit',
      reason: '',
      quantity: '',
      vouchers: "",
      transactions: "",
      checkedValues: [],
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.resendVoucher = this.resendVoucher.bind(this);
  }

  transferVoucher = (userID) => {
    isLoading = "true";
    const postData = {
      voucherID: this.state.transferVoucherID,
      userID: userID,
      site_id: localStorage.getItem("siteID")
    }

    this.props.voucherTransfer(postData);
  }

  handleSearch = (e) => {
    this.setState({[e.target.name]: e.target.value, searchValueError : ''});
    let searchstring = this.state.search.length > 1 ? this.state.search : "";
    const postData = {
      page: "1",
      limit: this.state.limit,
      search: searchstring,
      site_id: localStorage.getItem("siteID")
    };
    if (this.state.search.length !== 0) {
      this.props.getVoucherList(postData);
    }else{
      this.props.getVoucherList({
        page: "1",
        limit: this.state.limit,
        search: '',
        site_id: localStorage.getItem("siteID")
      });
    }
  }

  handleUserSearch = (e) => {
    e.preventDefault();
    if(!this.state.searchValue){
      this.setState({searchValueError: 'red'})
    }else{
      isLoading="true";
      this.props.allUser({search: this.state.searchValue, site_id: localStorage.getItem("siteID")});
    }
  }

  handleTransfer = (voucherID) => {
    this.setState({
      popUpTransfer: true,
      transferVoucherID: voucherID
    });
  }

  resendVoucher = (e) => {
    isLoading = "true";
    let voucherID = e.target.attributes.getNamedItem("data-id").value;
    this.props.resendVoucher({'voucherID': voucherID, site_id: localStorage.getItem("siteID")});
  }

  ClosePopupTransfer = (e) => {
    this.setState({
      popUpTransfer: false,
      transferVoucherID: '',
      searchValue: '',
      userList: '',
    });
  }

  handleRefund = (voucherID) => {
    isLoading="true";
    this.props.getVoucherDetail(voucherID, localStorage.getItem("siteID"));
    this.setState({
      transferVoucherID: voucherID
    });
  }

  CloseRefundPopup = (e) => {
    this.setState({
      popUpRefund: false,
      voucherDetail: '',
      amount: '',
      refundAs: 'StoreCredit',
      reason: '',
      quantity: '',
      vouchers: '',
      transactions: '',
    });
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handlePageChange = page => {
    this.setState({
      currentPage: page
    });

    const postData = {
      page: page,
      limit: this.state.limit,
      search: this.state.search ? this.state.search : "",
      site_id: localStorage.getItem("siteID")
    };
    this.props.getVoucherList(postData);
  };

  handleSort = orderBy => e => {
    e.preventDefault();

    let direction;
    const sortIcon = `${orderBy}SortIcon`;
    if (this.state.direction === "") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "fa fa-sort-up",
        direction: "ASC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "ASC") {
      direction = "DESC";
      this.setState({
        [sortIcon]: "fa fa-sort-down",
        direction: "DESC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "DESC") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "fa fa-sort-up",
        direction: "ASC",
        orderBy: orderBy
      });
    }
    this.props.getVoucherList({ site_id: localStorage.getItem("siteID"), orderBy: orderBy, direction: direction,limit: this.state.limit });
  };

  componentDidMount() {
    if(this.props.match && this.props.match.params && this.props.match.params.userId && this.props.match.params.userId.length>0){
      this.props.getVoucherList({site_id: localStorage.getItem("siteID"), page:1, userID: this.props.match.params.userId,limit: this.state.limit});
    }
    else{
      this.props.getVoucherList({site_id: localStorage.getItem("siteID"), page:this.state.currentPage,limit: this.state.limit});
    }
  }

  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.props.history.push("/restrictedAccess");
    }

    if (this.props.voucherlist !== nextProps.voucherlist) {
      if (nextProps.voucherlist) {
        const setPageCount =
          nextProps.voucherlist.data.total /
          nextProps.voucherlist.data.per_page;
        this.setState({
          voucherData: nextProps.voucherlist.data.data,
          totalRecords: nextProps.voucherlist.data.total,
          perPage: nextProps.voucherlist.data.per_page,
          pageCount: setPageCount
        });
      }
    }

    if (this.props.voucherDetails !== nextProps.voucherDetails) {
      if (nextProps.voucherDetails) {
        if (nextProps.voucherDetails.data) {
          isLoading = "false";
        }
        let offerdata = nextProps.voucherDetails.data;
        let checkVoucher = [];
        if(!isEmpty(nextProps.voucherDetails.data.vouchers)){
          nextProps.voucherDetails.data.vouchers.map((data, index) => {
            if(data.status == 'Active'){
              checkVoucher.push(data.voucherID)
            }
          });
        }

        this.setState({
          voucherDetail: offerdata,
          popUpRefund: true,
          amount: nextProps.voucherDetails.data.voucherValue,
          quantity: nextProps.voucherDetails.data.quantity,
          transactions: nextProps.voucherDetails.data.transactions,
          vouchers: nextProps.voucherDetails.data.vouchers,
          checkVoucher: checkVoucher,
        });

      }
    }

    if (this.props.userList !== nextProps.userList) {
      if (nextProps.userList) {
        isLoading="false";
        this.setState({
          userList: nextProps.userList.data,
        });
      }
    }

    if (this.props.transfer !== nextProps.transfer) {
      if (nextProps.transfer) {
        this.props.clearAlert();
        this.handleShow();       
        isLoading = "false";
        this.ClosePopupTransfer();
        this.props.getVoucherList({ page: this.state.currentPage,limit: this.state.limit, site_id: localStorage.getItem("siteID") });
        this.props.renderAlert("success", nextProps.transfer.message);
        window.scrollTo(0, 0);
      }
    }

    if (this.props.refundStatus !== nextProps.refundStatus) {
      if (nextProps.refundStatus) {
        this.props.clearAlert();
        this.handleShow();       
        isLoading = "false";
        this.CloseRefundPopup();
        this.props.getVoucherList({ page: this.state.currentPage,limit: this.state.limit, site_id: localStorage.getItem("siteID") });
        this.props.renderAlert("success", nextProps.refundStatus.message);
        window.scrollTo(0, 0);
      }
    }

    if (this.props.resendStatus !== nextProps.resendStatus) {
      if (nextProps.resendStatus) {
        this.props.clearAlert();
        this.handleShow();       
        isLoading = "false";
        this.props.getVoucherList({ page: this.state.currentPage,limit: this.state.limit, site_id: localStorage.getItem("siteID") });
        this.props.renderAlert("success", nextProps.resendStatus.message);
        window.scrollTo(0, 0);
      }
    }

    if (this.props.voucherStatus !== nextProps.voucherStatus) {
      if (nextProps.voucherStatus) {
        this.props.clearAlert();
        this.handleShow();

        if (nextProps.voucherStatus.message) {
          isLoading = "false";
          this.setState({popUpStatus: false, status: '', voucherID: ''});
          this.props.getVoucherList({ page: this.state.currentPage,limit: this.state.limit, site_id: localStorage.getItem("siteID") });
          this.props.renderAlert("success", nextProps.voucherStatus.message);
          window.scrollTo(0, 0);
        }
      }
    }
    if (nextProps.message) {
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        isLoading = "false";
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        this.CloseRefundPopup();
        window.scrollTo(0, 0);
      }
    }
  }

  handleNoteChange = (e) => {
    this.setState({note: e.target.value, noteError:""});
  }

  hadleStatus = (e) => {
    if(this.state.note){
      this.handleShow();
      isLoading = "true";
      let postdata = {
        status: this.state.status,
        note: this.state.note,
        site_id: localStorage.getItem("siteID")
      };
      this.props.updateStatus(this.state.voucherID, postdata);
    }else{
      this.setState({noteError:"red"});
    }
  }

  ClosePopup = (e) => {
    this.setState({popUpStatus: false, status: '', voucherID: ''});
  }
  changeStatus = (voucherID, status) => {
    this.setState({popUpStatus: true, status: status, voucherID: voucherID});
  };

  handleSearch(e) {
    this.setState({ [e.target.name]: e.target.value });
    let searchstring = this.state.search.length > 1 ? this.state.search : "";
    const postData = {
      page: "1",
      limit: this.state.limit,
      search: this.state.search,
      site_id: localStorage.getItem("siteID")
    };

    if (this.state.search.length !== 0) {
      this.props.getVoucherList(postData);
    } else {
      this.props.getVoucherList({ site_id: localStorage.getItem("siteID"), page: this.state.currentPage,limit: this.state.limit });
    }
  }

  handleChange = (e) => {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  refundProcess = (e) => {
    e.preventDefault();
    let valid = this.validate();
    isLoading = "false";
    if(valid){
      const constData = {
        refundAs: this.state.refundAs,
        amount: (this.state.amount) ? this.state.amount : this.state.voucherDetail.voucherValue,
        status: 'refund',
        voucherStatus: this.state.voucherDetail.status,
        reason: this.state.reason,
        voucherID: this.state.checkVoucher,
        site_id: localStorage.getItem("siteID")
      }

      this.props.refundVoucher(constData);
    }

    
  }

  validate = (e) => {
    let returnValue = true;

    if(!this.state.reason){
      returnValue = false;
      this.setState({reasonError: "red"});
    }

    if(isEmpty(this.state.checkVoucher)){
      returnValue = false;
      this.setState({checkVoucherError: "Minimum 1 voucher is required for refund."});
    }

    return returnValue;
  }

  handleVoucherID = (e) => {
    let checkVoucher = this.state.checkVoucher;
    let index;
    if (e.target.checked) {
      this.setState({checkVoucher: ""});
      checkVoucher.push(parseInt(e.target.value));
    } else {
      index = checkVoucher.indexOf(parseInt(e.target.value));
      checkVoucher.splice(index, 1);
    }
    this.setState({ checkVoucher: checkVoucher });
  }

  render() {
    const { path } = this.state;
    const { currentPage, totalRecords, perPage, pageCount } = this.state;
    let voucherRow;
    let voucherListData = this.state.voucherData ? this.state.voucherData : [];
    if (!isEmpty(voucherListData)) {
      voucherRow = voucherListData.map((voucher, index) => (
        <tr key={voucher.voucherID}>
          <td>{voucher.voucherNumber}</td>
          <td>{voucher.email} </td>
          <td>{voucher.dealText}</td>

          <td>{moment(voucher.expiryDate).format("DD-MM-YYYY")}</td>
          <td>{voucher.status}</td>
          <td>
            <ButtonGroup>
                <DropdownButton title="Action" id="bg-nested-dropdown">
                      {aclUtil.checkACL('CHANGE_STATUS') ? (voucher.status == "Active" ? (
                        <MenuItem eventKey={Math.random()} onClick={this.changeStatus.bind(
                              this,
                              voucher.voucherID,
                              "Void"
                            )}><i className="fa fa-eye"></i> Void</MenuItem>
                        ) : voucher.status == "Redeemed" ? (
                          <MenuItem eventKey={Math.random()} onClick={this.changeStatus.bind(
                              this,
                              voucher.voucherID,
                              "Active"
                            )}><i className="fa fa-eye"></i> Active</MenuItem>
                        ) : (
                          <MenuItem eventKey={Math.random()} onClick={this.changeStatus.bind(
                              this,
                              voucher.voucherID,
                              "Active"
                            )}><i className="fa fa-eye"></i> Active</MenuItem>
                        )) :("")}


                  {aclUtil.checkACL('EDIT_VOUCHER') ? (<MenuItem eventKey={Math.random()} onClick={() => history.push(`/editVoucher/${voucher.voucherID}`)}><i className="fa fa-pencil-square-o"></i> Edit</MenuItem>) :("")}
                   {aclUtil.checkACL('TRANSFER_VOUCHER') ? (<MenuItem eventKey={Math.random()} onClick={this.handleTransfer.bind(this, voucher.voucherID)}><i className="fa fa-paper-plane"></i> Transfer</MenuItem>) :("")}
                   {aclUtil.checkACL('REFUND_VOUCHER') ? (<MenuItem eventKey={Math.random()} onClick={this.handleRefund.bind(this, voucher.voucherID)}><i className="fa fa-usd"></i> Refund</MenuItem>) :("")}
                   <MenuItem eventKey={Math.random()} onClick={() => history.push(`/printVouchers/${voucher.voucherID}`)}><i className="fa fa-print"></i> Print</MenuItem>
                   {aclUtil.checkACL('ADD_REMOVE_STORE_CREDIT') ? (<MenuItem eventKey={Math.random()} onClick={() => history.push(`/store-credit-preview/${voucher.userID}`)}><i className="fa fa-plus"></i> Store Credit</MenuItem>) :("")}
                   {aclUtil.checkACL('ORDERS') ? (<MenuItem eventKey={Math.random()} onClick={() => history.push(`/orders/${voucher.userID}`)}><i className="fa fa-eye"></i> Order History</MenuItem>) : ("")}
                   <MenuItem eventKey={Math.random()} data-id={voucher.voucherID} onClick={this.resendVoucher}><i className="fa fa-paper-plane"></i> Resend Voucher</MenuItem>
                </DropdownButton>
            </ButtonGroup>
          </td>
        </tr>
      ));
    }

    return (
      <div>
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />
        <div className="col-lg-12 user-list list-page ">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links}/>
            </div>
          </div>
          <div className="panel">
          <header className="panel-heading panel-heading-index">
              <div className="row">
                <div className="col-lg-6 col-md-4 col-sm-12">
                  <h4>Vouchers List</h4>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-12 pull-right">
                  <FormGroup>
                    <InputGroup>
                      <FormControl type="text" name="search" onChange={this.handleSearch} />
                      <InputGroup.Addon>
                        <Glyphicon glyph="glyphicon glyphicon-search" />
                      </InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-12">
                  {/*<Button
                    bsSize="small"
                    bsStyle="success"
                    onClick={() => history.push("/generateVoucher")}
                  >
                    + Generate Voucher
                  </Button>
                  <Button
                    bsSize="small"
                    bsStyle="success"
                    onClick={() => history.push("/store-credit")}
                  >
                    + Store Credit
                  </Button>*/}
                </div>
              </div>
            </header>
            <div className="panel-body">
              {this.state.show &&
                this.state.alertMessage !== "" && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>{this.state.msgType}:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
              <div className="row">
                <div className="col-lg-12">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th onClick={this.handleSort("voucherNumber")}>
                          Voucher Number{" "}
                          <span
                            className={this.state.voucherNumberSortIcon}
                            aria-hidden="true"
                          />{" "}
                        </th>
                        <th>Email </th>

                        <th onClick={this.handleSort("dealText")}>
                          Offer{" "}
                          <span
                            className={this.state.dealTextSortIcon}
                            aria-hidden="true"
                          />
                        </th>

                        <th>Expiry Date </th>

                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>{voucherRow}</tbody>
                  </table>

                  <div className="text-center">
                    <Pagination
                      total={totalRecords}
                      limit={perPage}
                      pageCount={pageCount}
                      currentPage={currentPage}
                    >
                      {({
                        pages,
                        currentPage,
                        hasNextPage,
                        hasPreviousPage,
                        previousPage,
                        nextPage,
                        totalPages,
                        getPageItemProps
                      }) => (
                        <div className="pagination">
                          <button className="btn btn-default"
                            {...getPageItemProps({
                              pageValue: 1,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            first
                          </button>

                          {hasPreviousPage && (
                            <button className="btn btn-default"
                              {...getPageItemProps({
                                pageValue: previousPage,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {"<"}
                            </button>
                          )}

                          {pages.map(page => {
                            let activePage = null;
                            if (currentPage === page) {
                              activePage = {
                                backgroundColor: "#ccc",
                                color: "#666"
                              };
                            }
                            return (
                              <button className="btn btn-default"
                                key={page}
                                style={activePage}
                                {...getPageItemProps({
                                  pageValue: page,
                                  onPageChange: this.handlePageChange
                                })}
                              >
                                {page}
                              </button>
                            );
                          })}

                          {hasNextPage && (
                            <button className="btn btn-default"
                              {...getPageItemProps({
                                pageValue: nextPage,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {">"}
                            </button>
                          )}

                          <button className="btn btn-default"
                            {...getPageItemProps({
                              pageValue: totalPages,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            last
                          </button>
                        </div>
                      )}
                    </Pagination>
                  </div>
                </div>
              </div>
              <div className="clearfix" />
            </div>
          </div>
        </div>
        <Modal show={this.state.popUpStatus} onHide={this.ClosePopup} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>Add Note</Modal.Title>
          </Modal.Header>
          <Modal.Body>
             <FormGroup>
                  <ControlLabel>Note</ControlLabel>
                  <FormControl
                    type="text"
                    value={this.state.note}
                    placeholder="Enter Note"
                    name="note"
                    onChange={this.handleNoteChange}
                    style={{borderColor:this.state.noteError}}
                  />
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="success" onClick={this.hadleStatus}>Save</Button>
            <Button bsStyle="danger" onClick={this.ClosePopup}>Close</Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.popUpTransfer} onHide={this.ClosePopupTransfer} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>Transfer Voucher</Modal.Title>
          </Modal.Header>
          <Modal.Body>
             <FormGroup>
              <InputGroup>
                <FormControl type="text" name="searchValue" style={{borderColor: this.state.searchValueError}} value={this.state.searchValue} onChange={this.handleSearch} />
                <InputGroup.Button>
                  <Button onClick={this.handleUserSearch}><i className="fa fa-search"></i> Search</Button>
                </InputGroup.Button>
              </InputGroup>
            </FormGroup>
            <hr/>
            {(this.state.userList) &&
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Email</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {this.state.userList.map((user, index) => 
                <tr key={user.user_id}>
                  <td>{user.firstName}</td>
                  <td>{user.lastName}</td>
                  <td>{user.email}</td>
                  <td>
                    <Button
                      bsSize="xsmall"
                      bsStyle="warning"
                      onClick={this.transferVoucher.bind(this, user.user_id)}
                    >
                      {" "}
                      Transfer
                    </Button>
                  </td>
                </tr>
                )}
              </tbody>
            </table>
            }
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={this.ClosePopupTransfer}>Close</Button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.popUpRefund}  bsSize="large" onHide={this.CloseRefundPopup} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title>Refund Voucher</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md={12} xs={12}><b>Transactions</b></Col>
              <Col md={12} xs={12}><hr/></Col>
               <Col md={12} xs={12}>
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Qty.</th>
                    <th>Transaction ID</th>
                    <th>Base Price</th>
                    <th>Charged To Card</th>
                    <th>Credit Used</th>
                    <th>Discount</th>
                    <th>Last 4CC</th>
                    <th>Date Ordered</th>
                  </tr>
                </thead>
                <tbody>
                  {(this.state.transactions) &&
                    this.state.transactions.map((data, index) =>
                      <tr key={`transactions${index}`}>
                        <td>{++index}</td>
                        <td>{data.quantity}</td>
                        <td>{data.payment_id}</td>
                        <td>${data.amount}</td>
                        <td>${(parseInt(data.amount) - parseInt(data.store_credit_amount))}</td>
                        <td>${data.store_credit_amount}</td>
                        <td>${(data.discount) ? data.discount : '0.00'}</td>
                        <td>{data.cardNumber}</td>
                        <td>{data.created_on}</td>
                      </tr>
                    )
                  }
                </tbody>
              </table>
              </Col>
              <Col md={12} xs={12}><b>Vouchers</b></Col>
              <Col md={12} xs={12}><hr/></Col>
              <Col md={12} xs={12}>
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>Void?</th>
                      <th>Voucher #</th>
                      <th>Transaction ID</th>
                      <th>Print Count</th>
                      <th>Status</th>
                      <th>Date Orderd</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(this.state.vouchers) &&
                      this.state.vouchers.map((data, index) =>
                        <tr key={`vouchers${index}`}>
                          <td>
                            {(data.status == 'Active') ?
                              <FormGroup>
                                {this.state.checkVoucher.indexOf(data.voucherID) > -1 ? (
                                <Checkbox inline checked={true} onChange={this.handleVoucherID} value={data.voucherID}></Checkbox>
                                ) : (
                                <Checkbox inline onChange={this.handleVoucherID} value={data.voucherID}></Checkbox>
                                )}
                              </FormGroup>
                            :
                              <FormGroup>
                                <Checkbox inline disabled={true}></Checkbox>
                              </FormGroup>
                            }
                          </td>
                          <td>{data.voucherNumber}</td>
                          <td>{data.transaction_id}</td>
                          <td>{data.print_count}</td>
                          <td>{data.status}</td>
                          <td>{data.createdOn}</td>
                        </tr>
                      )
                    }
                  </tbody>
                </table>
              </Col>
            
              <Col md={6} xs={12}>
                <Row>
                  <Col md={12} xs={12}><h3>Refunds</h3></Col>
                  <Col md={12} xs={12}><hr/></Col>
                  <Col md={12} xs={12}>
                  {(this.state.voucherDetail && this.state.voucherDetail.refund.length > 0) ?
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>Amount</th>
                          <th>Type</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(this.state.voucherDetail.refund.length > 0) ?
                          this.state.voucherDetail.refund.map((data, index) => 
                            <tr>
                              <td>{data.amount}</td>
                              <td>{data.paymentMethod}</td>
                              <td>{data.refunded_on}</td>
                            </tr>
                          )
                          :
                          <tr>
                            <td colSpan={3}>No refunds have been issued.</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  :
                    'No refunds have been issued.'
                  }
                  </Col>
                </Row>
              </Col>
              <Col md={6} xs={12}>
                <Row>
                  <Col  md={12} xs={12}><h3>Credit User</h3></Col>
                  <Col  md={12} xs={12}><hr/></Col>
                  <Col md={12} xs={12} className="text-danger">
                  {(this.state.checkVoucherError !== '') &&  
                    <Row>
                      <Col  md={12} xs={12}>
                        {this.state.checkVoucherError}
                      </Col>
                    </Row>
                  }
                  </Col>
                  <Col  md={12} xs={12}>
                    <Row>
                      <Col  md={4} xs={12}>
                        Amount:
                      </Col>
                      <Col  md={4} xs={12}>
                        <FormGroup
                          controlId="formBasicText"
                        >
                          <FormControl
                            type="text"
                            value={this.state.amount}
                            placeholder="Amount"
                            onChange={this.handleChange}
                            name="amount"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={4} xs={12}>
                        <FormGroup
                          controlId="formBasicText"
                        >
                          <FormControl componentClass="select" name="refundAs" value={this.state.refundAs} onChange={this.handleChange}>
                            <option value="StoreCredit">As Store Credit</option>
                            <option value="CreditCard">To Credit Card</option>
                          </FormControl>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={4} xs={12}>Reason:</Col> 
                      <Col md={8} xs={12}>
                        <FormGroup controlId="formControlsTextarea">
                          <FormControl 
                            componentClass="textarea" 
                            name="reason" 
                            value={this.state.reason} 
                            onChange={this.handleChange} 
                            placeholder="Reason" 
                            style={{ borderColor: this.state.reasonError }} 
                          />
                        </FormGroup>
                      </Col> 
                    </Row>
                    <Row>
                      <Col md={8} xs={12}>Number of Vouchers being Refunded:</Col> 
                      <Col md={4} xs={12}>
                        <FormGroup
                          controlId="formBasicText"
                        >
                          <FormControl
                            type="number"
                            name="quantity"
                            value={this.state.quantity}
                            onChange={this.handleChange}
                            style={{ borderColor: this.state.quantityError }} 
                          />
                        </FormGroup>
                      </Col> 
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="success" onClick={this.refundProcess}>Refund</Button>
            <Button bsStyle="danger" onClick={this.CloseRefundPopup}>Close</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  userList: state.subAdminReducer.userList,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
  voucherlist: state.voucherReducer.voucherlist,
  voucherStatus: state.voucherReducer.voucherStatus,
  transfer: state.voucherReducer.transfer,
  voucherDetails: state.voucherReducer.voucherDetails,
  refundStatus: state.voucherReducer.refundStatus,
  error: state.voucherReducer.error,
  resendStatus: state.voucherReducer.resendStatus,
});

export default withRouter(connect(mapStateToProps, {
  renderAlert,
  clearAlert,
  updateStatus,
  getVoucherList,
  allUser,
  voucherTransfer,
  getVoucherDetail,
  refundVoucher,
  resendVoucher
})(VouchersList));



// WEBPACK FOOTER //
// ./src/app/views/admin/voucher/VouchersList.js